<template>
    <Head title="My Points" />
    <div class="px-4 md:px-8">
        <MyPoints />
    </div>
</template>
<script setup>
import { Head } from '@inertiajs/vue3';
import MyPoints from '@/components/mypoints/index.vue';
</script>
